import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import styles from './AddBESS.module.css';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormLabel,
  MenuItem,
  Select
} from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export default function SystemInfoFormGroup({
  systemName,
  setSystemName,
  systemLocation,
  setSystemLocation,
  systemOrganization,
  setSystemOrganization,
  systemSensors,
  setSystemSensors
}) {
  const { t } = useTranslation();
  const organizations = useSelector(
    (state) => state.organizationReducer.organizations
  );

  const handleSystemNameChange = (e) => {
    setSystemName(e.target.value);
  };
  const handleSystemLocationChange = (e) => {
    setSystemLocation(e.target.value);
  };
  const handleSystemAccessChange = (e) => {
    setSystemOrganization(e.target.value);
  };

  const handleSystemSensorChecked = (sensorName) => {
    const systemSensorsCopy = [...systemSensors];
    const index = systemSensorsCopy.findIndex(
      (sensor) => sensor.name === sensorName
    );
    systemSensorsCopy[index].checked = !systemSensorsCopy[index].checked;
    setSystemSensors(systemSensorsCopy);
  };

  return (
    <FormGroup className={styles.systemInfoFormGroup}>
      <FormControl required={true} variant="outlined">
        <InputLabel htmlFor="component-outlined">{t('systemName')}</InputLabel>
        <OutlinedInput
          id="component-outlined"
          value={systemName}
          onChange={handleSystemNameChange}
          label={t('systemName')}
        />
      </FormControl>
      <FormControl required={true} variant="outlined">
        <InputLabel htmlFor="component-outlined">{t('location')}</InputLabel>
        <OutlinedInput
          id="component-outlined"
          value={systemLocation}
          onChange={handleSystemLocationChange}
          label={t('location')}
        />
      </FormControl>
      <FormControl required={true} variant="outlined">
        <InputLabel htmlFor="component-outlined">
          {t('organization')}
        </InputLabel>
        <Select
          id="component-outlined"
          value={systemOrganization}
          onChange={handleSystemAccessChange}
          label={t('organization')}
        >
          {organizations.map((organization) => (
            <MenuItem key={organization.organizationId} value={organization}>
              {organization.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FormControl className={styles.systemSensorsFormControl}>
        <FormLabel>{t('systemSensors')}</FormLabel>
        <div className={styles.systemSensorsContainer}>
          {systemSensors.map((sensor) => (
            <FormControlLabel
              key={sensor.name}
              control={
                <Checkbox
                  checked={sensor.checked}
                  onChange={() => handleSystemSensorChecked(sensor.name)}
                />
              }
              label={t(sensor.name)}
            />
          ))}
        </div>
      </FormControl>
    </FormGroup>
  );
}
